import React, { useState } from "react";
import { setLocation, useStoreLocation } from "../../../context/StoreLocation";
import { IItemPathToRoute } from "../../../models/item.model";
import { useAuthState } from "../../../context/UserAuthentication";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import {
  setShowCart,
  updateIsOrderTypeSelected,
  updateOrderDetails,
  updateOrderType
} from "../../../redux/slices/cartSlice";
import {
  GUEST_USER,
  ROUTE_CHECKOUT,
  ROUTE_CHECKOUT_CURBSIDE,
  ROUTE_LOCATIONS,
  ROUTE_MENU,
  ROUTE_ORDER,
} from "../../../constants";
import { useQueryClient } from "react-query";
import { useNavigate, useLocation } from "react-router";
import ConfirmLocationChangeModal from "./ConfirmLocationChangeModal";
import * as CONSTANT from "../../../constants";
import { Spinner } from "react-bootstrap";
import useGetFavoriteLocations from "../../../react-query-hooks/useGetNearbyLocations";
import SelectedLocationForPickup from "./SelectedLocationForPickup";
import FavoriteLocationsDropDown from "./FavoriteLocationsDropDown";
import ChangeLocation from "../../../containers/order/StoreLocation/ChangeLocation";
import { trackSelectOrderTypeClick } from "../../../analytics/pulseSelectOrderTypeClick";
import type { OrderTypeModalSource } from "../../../analytics/pulseSelectOrderTypeClick";

interface IOrderPickupTab {
  itemPath: IItemPathToRoute,
  handleOrderTypeModal: () => void,
  showItemPickupDateTime?: boolean,
  handleShowPickupMethodModal?: (boolean) => void,
  saveSelectedOrderType?: string,
  handleSavedOrderType?: () => void,
  isItMobile: boolean,
  selectedOrderType?: string,
  modalSource?: OrderTypeModalSource,
}
function OrderPickupTabV2(props: IOrderPickupTab) {
  const {
    itemPath,
    handleOrderTypeModal,
    showItemPickupDateTime,
    handleShowPickupMethodModal,
    saveSelectedOrderType,
    selectedOrderType,
    modalSource,
  } = props
  const location = useLocation();
  const { locationInfo, dispatch: locationDispatch } = useStoreLocation();
  const queryClient = useQueryClient();
  const location_id = locationInfo.selectedStore?.id;
  const [selectedLocation, setSelectedLocation] = useState(locationInfo.selectedStore);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { authInfo } = useAuthState();
  const previousOrderType = selectedOrderType;

  const { data, isFetching: isFetchingFavoriteLocations } =
    useGetFavoriteLocations(authInfo.userId, authInfo.type === GUEST_USER, false);

  const history = useNavigate();
  const orderTypeDispatch = useAppDispatch();
  const isCartOpen = useAppSelector((state) => state.cart.showCart);
  const handleSaveOrderType = (orderType: string) => {
    orderTypeDispatch(updateOrderType(orderType));
  };

  const handleConfirmationModal = (currentSelectedLocation?) => {
    if(!locationInfo?.selectedStore?.id) return false;
    const locationToUse = currentSelectedLocation || selectedLocation;
    return (locationToUse.id !== location_id || previousOrderType !== saveSelectedOrderType)
      && (location.pathname.includes(CONSTANT.ROUTE_ORDER))     
  }

  const routeToItem = (currentSelectedLocation?) => {
    const locationToUse = currentSelectedLocation || selectedLocation;
    setIsSubmitting(true);
    //this if condition checks  user is changing location while being on item customization page.
    const shouldShowConfirmation = handleConfirmationModal(locationToUse);
    if ( shouldShowConfirmation) {
      setShowConfirmationModal(true);
    } else {
      confirmLocationChange(locationToUse);
    }
  }

  const confirmLocationChange = (currentSelectedLocation?) => {
    const locationToUse = currentSelectedLocation || selectedLocation;
      trackSelectOrderTypeClick({
        label: 'Pickup',
        page_path: location.pathname,
        modalSource,
        isCartOpen,
      });
      orderTypeDispatch(updateIsOrderTypeSelected(true));
      setLocation(locationDispatch, locationToUse);
      queryClient.refetchQueries(["get-cart", locationToUse.id]);
      orderTypeDispatch(updateOrderDetails(null));
      handleOrderTypeModal();
      if (saveSelectedOrderType) { handleSaveOrderType(saveSelectedOrderType) }
      if (showItemPickupDateTime) { handleShowPickupMethodModal(true) }
      if (showConfirmationModal) {
        setShowConfirmationModal(false);
        history(ROUTE_MENU);
      } else if (location.pathname.includes(ROUTE_ORDER)){
        const target = { pathname: location.pathname, search: location.search };
        history(target, { replace: true });
      } else if (
        location.pathname.includes(ROUTE_CHECKOUT) 
      ) {
        history(
          { pathname: location.pathname, search: location.search },
          { replace: true }
        );
      } else if (itemPath) {
        history(itemPath)
      }
  }

  const onCloseConfirmationMoal = () => {
    setShowConfirmationModal(false);
    setIsSubmitting(false)
  }

  if (isFetchingFavoriteLocations)
    return (
      <div className="position-relative mt-5 py-5">
        <Spinner
          animation="border"
          className="position-absolute bottom-50 end-50"
        />
      </div>
    );

  return (
    <div className="mt-4 mx-3">
        <ChangeLocation closeModal={() => handleOrderTypeModal()} handleContinueButton={routeToItem} setSelectedLocation={setSelectedLocation}/>
      <ConfirmLocationChangeModal
        showModal={showConfirmationModal}
        handleClose={() => onCloseConfirmationMoal()}
        confirmChange={() => confirmLocationChange()}
        loading={false}
      />
    </div>
  );
}
export default OrderPickupTabV2;
